import { useTranslation } from 'react-i18next';
import { ButtonAccentPrimary, ButtonAccentSecondary } from '@components/button';
import { IconCross } from '@components/icons';
import classNames from 'classnames';

import { ModalV2 } from '../../modal-v2';

import { Props } from './confirm-modal.types';

export const ConfirmModal = ({
  isOpen,
  title,
  icon,
  titleClassName = 'text-primary text-headline-m sm:text-headline-l',
  bodyText,
  bodyTextClassName = 'text-secondary text-body-s',
  confirmTextButton,
  denyTextButton,
  handleClose,
  handleClickConfirm,
  handleClickDeny,
}: Props) => {
  const { t } = useTranslation();

  return (
    <ModalV2 isOpen={isOpen} onClose={handleClose} variant='sm'>
      <div className='flex justify-end m-6 mb-3'>
        <button
          data-testid='confirm_modal__cross-button'
          className='flex justify-center items-center'
          onClick={handleClose}>
          <IconCross className='text-primary w-6 h-6' />
        </button>
      </div>
      <div className='flex flex-col gap-4 items-center mx-6 mb-10'>
        {!!icon && icon}
        <p data-testid='confirm_modal__title' className={classNames('text-center', titleClassName)}>
          {title}
        </p>
        {bodyText && <p className={classNames('mx-2 text-center', bodyTextClassName)}>{bodyText}</p>}
        <div className='flex gap-4 mt-2 flex-wrap justify-center md:flex-row-reverse'>
          <ButtonAccentPrimary
            data-testid='confirm_modal__confirm-button'
            className='w-full md:w-fit'
            onClick={handleClickConfirm}>
            {confirmTextButton ?? t('common:yes')}
          </ButtonAccentPrimary>
          <ButtonAccentSecondary
            data-testid='confirm_modal__deny-button'
            className='w-full md:w-fit'
            onClick={handleClickDeny ?? handleClose}>
            {denyTextButton ?? t('common:no')}
          </ButtonAccentSecondary>
        </div>
      </div>
    </ModalV2>
  );
};
